import { BillingModel } from '@stigg-types/apiTypes';

export function isFeatureMetered(billingModel: BillingModel) {
  return [BillingModel.PerUnit, BillingModel.UsageBased].includes(billingModel);
}
